<template>
  <div class="profile-page">
    <!-- 背景装饰 -->
    <div class="page-bg">
      <div class="bg-orb orb-1"></div>
      <div class="bg-orb orb-2"></div>
      <div class="bg-orb orb-3"></div>
    </div>

    <div class="page-container">
      <!-- ===== 顶部用户信息 ===== -->
      <div class="profile-header">
        <div class="user-info">
          <div class="user-avatar">
            <img
              v-if="userInfo.avatar"
              :src="userInfo.avatar"
              :alt="$t('member.avatarAlt')"
              class="avatar-img"
            />
            <svg
              v-else
              class="avatar-default"
              viewBox="0 0 24 24"
              width="32"
              height="32"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <span class="avatar-status"></span>
          </div>
          <div class="user-detail">
            <div class="user-name-wrap">
              <h2 class="user-name">
                {{ userInfo.first_name }} {{ userInfo.last_name }}
              </h2>
              <button
                class="btn-settings"
                @click="handleSettings"
                :title="$t('member.settingsTitle')"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"
                  />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
              <button
                class="btn-logout-icon"
                @click="handleLogout"
                :title="$t('member.logoutTitle')"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                  <polyline points="16 17 21 12 16 7"></polyline>
                  <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
              </button>

            </div>
            <p class="user-id">UID: {{ userInfo.uid }}</p>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="action-buttons">
          <button class="action-btn btn-recharge" @click="handleRecharge">
            {{ $t("member.recharge") }}
          </button>
          <button class="action-btn btn-withdraw" @click="handleWithdraw">
            {{ $t("member.withdraw") }}
          </button>
        </div>
      </div>

      <!-- ===== 总资产卡片 ===== -->
      <!-- <div class="asset-card">
        <div class="asset-header">
          <span class="asset-label">总资产</span>
          <span class="asset-currency">USD</span>
        </div>
        <div class="asset-amount">
          <span class="currency-sign">$</span>
          <span class="amount-number">19,852.00</span>
        </div>
        <div class="asset-change">
          <span class="change-up">↑ 2.4%</span>
          <span class="change-label">较昨日</span>
        </div>
        <div class="asset-chart-mini">
          <svg viewBox="0 0 200 30" class="mini-chart">
            <polyline
              points="0,25 20,20 40,22 60,15 80,18 100,10 120,12 140,8 160,5 180,3 200,0"
              fill="none"
              stroke="#00b4ff"
              stroke-width="2"
            />
            <polyline
              points="0,25 20,20 40,22 60,15 80,18 100,10 120,12 140,8 160,5 180,3 200,0"
              fill="none"
              stroke="#00b4ff"
              stroke-width="4"
              opacity="0.2"
            />
          </svg>
        </div>
      </div> -->

      <!-- ===== 会员信息卡片 ===== -->
      <MemberBox />

      <!-- ===== Tab导航（纯文字 + 底部边框） ===== -->
      <div class="tab-nav">

        <div
          v-for="tab in tabs"
          :key="tab.key"
          class="tab-nav-item"
          :class="{ active: currentTab === tab.key }"
          @click="switchTab(tab.key)"
        >
          {{ $t(tab.label) }}
        </div>
      </div>

      <!-- ===== 内容区域 ===== -->
      <div class="tab-content">
        <!-- 产品列表 -->
        <Product v-if="currentTab === 'products'" />

        <!-- 历史记录 -->
        <History v-if="currentTab === 'history'" />

        <!-- 钱包记录 -->
        <WalletLogList v-if="currentTab === 'walletLog'" />

        <!-- 存币记录 -->
        <Deposit v-show="currentTab === 'deposits'" />

        <!-- 提现记录 -->
        <Withdrawal v-if="currentTab === 'withdraws'" />

        <!-- 提现地址 -->
        <Addresse v-show="currentTab === 'addresses'" />
      </div>

      <!-- ===== 底部操作 ===== -->
      <!-- <div class="footer-actions">
        <button class="btn-footer" @click="handleLogout">退出登录</button>
      </div> -->
    </div>
  </div>
</template>

<script>
import consts from "@/utils/consts";
import Product from "@/components/member/product/Product.vue";
import History from "@/components/member/history/History.vue";
import Deposit from "@/components/member/Deposit.vue";
import Withdrawal from "@/components/member/Withdrawal.vue";
import Addresse from "@/components/member/Addresse.vue";
import WalletLogList from "@/components/member/wallet/WalletLogList.vue";
import MemberBox from "@/components/member/MemberBox.vue";


export default {
  name: "ProfilePage",
  components: {
    Product,
    History,
    Deposit,
    Withdrawal,
    Addresse,
    WalletLogList,
    MemberBox,
  },
  data() {
    return {
      currentTab: "products",
      tabs: [
        { key: "products", label: "member.tabProducts" },
        { key: "history", label: "member.tabHistory" },
        { key: "walletLog", label: "member.tabWalletLog" },
        { key: "deposits", label: "member.tabDeposits" },
        { key: "withdraws", label: "member.tabWithdraws" },
        { key: "addresses", label: "member.tabAddresses" },
      ],
      userInfo: {},
    };
  },

  created() {
    this.getUserInfo();
    // 判断 URL 是否有 tab 参数，有则切换到对应 tab
    const tab = this.$route.query.tab;
    if (tab) {
      const exists = this.tabs.some((item) => item.key === tab);
      if (exists) {
        this.currentTab = tab;
      }
    }
  },
  watch: {
    // 监听 URL 的 tab 参数变化（例如点击顶部菜单跳转到 /member?tab=products）
    "$route.query.tab"(newTab) {
      if (newTab) {
        const exists = this.tabs.some((item) => item.key === newTab);
        if (exists) {
          this.currentTab = newTab;
        }
      }
    },
  },
  methods: {
    getUserInfo() {

      this.$api.user.getUserInfo().then((res) => {
        if (res.code === 1) {
          this.$message.error(res.msg);
          return;
        }
        this.userInfo = res.data;
      });
    },
    switchTab(key) {
      this.currentTab = key;
      // 同步更新 URL 的 tab 参数
      // this.$router
      //   .replace({ name: "Member", query: { tab: key } })
      //   .catch(() => {});
    },

    handleRecharge() {
      // console.log("打开充值弹窗");
      this.$router.push("/deposit");
    },
    handleWithdraw() {
      // console.log("打开提现弹窗");
      this.$router.push("/withdraw");
    },
    handleSettings() {
      console.log("打开设置页面");
      this.$router.push("/setting");
    },
    handleDetail(item) {
      console.log("查看产品详情:", item);
    },

    handleLogout() {
      localStorage.removeItem(consts.KEY_TOKEN);
      localStorage.removeItem(consts.KEY_INFO);
      this.$message.success(this.$t("menu.logoutSuccess"));
      this.$router.push({ name: "Login" }).catch(() => {});
    },

  },
};
</script>

<style>
@import "@/assets/member.css";
</style>
